import { withSentryReactRouterV7Routing } from "@sentry/react";
import { Routes, Route, Navigate, useMatch, useParams } from "react-router";
import clsx from "clsx";
import Fragments from "./views/fragments";
import StudentSurvey from "./views/student_survey";
import Dashboard from "./views/dashboard";
import DashboardPosts from "./views/dashboard_posts";
import Header from "./components/header";
import Footer from "./components/footer";
import CATEGORIES from "./data/categories";
import { createContext, useState } from "react";

const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export const PostsContext = createContext();

function LegacyDashboardRedirect() {
  const { id } = useParams();

  return (
    <Navigate
      replace
      to={
        id
          ? `/${CATEGORIES.voeding.slug}/dashboard/${encodeURIComponent(id)}`
          : `/${CATEGORIES.voeding.slug}/dashboard`
      }
    />
  );
}

export default function App() {
  const isDashboard = useMatch("/:category/dashboard/:id") !== null;
  const [posts, setPosts] = useState([]);

  return (
    <div className={clsx("page", isDashboard && "page--no-background")}>
      <Header />
      <main
        className={clsx("page__main", isDashboard && "page__main--dashboard")}
      >
        <PostsContext.Provider value={{ posts, setPosts }}>
          <SentryRoutes>
            <Route
              path="/"
              element={<Navigate to={`/${CATEGORIES.voeding.slug}`} replace />}
            />
            <Route path="/dashboard" element={<LegacyDashboardRedirect />} />
            <Route
              path="/dashboard/:id"
              element={<LegacyDashboardRedirect />}
            />
            <Route path="/:category" element={<Fragments />} />
            <Route path="/:category/dashboard" element={<Dashboard />} />
            <Route
              path="/:category/dashboard/:id"
              element={<DashboardPosts />}
            />
            <Route path="/:category/:fragment" element={<StudentSurvey />} />
          </SentryRoutes>
        </PostsContext.Provider>
      </main>
      <Footer />
    </div>
  );
}
